import React, { useContext, useEffect, useState } from 'react';

import { makeStyles } from '@mui/styles';
import Box from '@mui/material/Box';
import { get as _get } from 'lodash';

import DataContext from '../../data/data-context';

const useStyles = makeStyles(theme => ({
    header: {
        position: 'fixed',
        top: '0px',
        width: '100%',
        height: '30px',
        lineHeight: '30px',
        textAlign: 'center',
        background: theme.palette.nav.banner,
        zIndex: 2000,
        overflow: 'auto',
        color: theme.palette.common.white,
    },
}));

const HeaderMessage = (props) => {
    const classes = useStyles();
    const { systemSettings } = useContext(DataContext);
    const [message, setMessage] = useState('');

    useEffect(() => {
        if (systemSettings) {
            setMessage(_get(systemSettings, 'ui.messages.header'));
        }
    }, [systemSettings]);

    return (
        <Box className={classes.header}>{props.message || message || ''}</Box>
    );
};
export default HeaderMessage;
